import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IdentityService } from 'src/app/services/identity.service';
import { TeamsService } from 'src/app/services/teams.service';

@Component({
    selector: 'app-team-page',
    templateUrl: './team-page.component.html',
    styleUrls: ['./team-page.component.scss'],
    standalone: false
})
export class TeamPageComponent implements OnInit, OnDestroy {
  private _subs: Subscription[] = [];

  constructor(
    private readonly _identity: IdentityService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _teams: TeamsService
  ) {}

  ngOnInit(): void {
    this._subs.push(
      this._activatedRoute.params.subscribe((params) => {
        if (params.team) {
          const localMode = window['env']?.['skipAuth'] || window['env']?.['localMode'];
          if (localMode && params.team !== 'local') {
            this._router.navigate(['/', 'local']);
            return;
          }

          this._identity.setTeam(params.team);
          localStorage.setItem('lastTeamSelected', params.team);

          // Validate team exists — redirect if not found in user's teams
          if (!localMode) {
            this._subs.push(
              this._teams.load().subscribe((teams) => {
                if (teams.length > 0) {
                  const valid = teams.some(t => (t.slug || t.name) === params.team);
                  if (!valid) {
                    const first = teams[0];
                    const slug = first.slug || first.name;
                    console.log(`Team "${params.team}" not in user teams, redirecting to "${slug}"`);
                    localStorage.setItem('lastTeamSelected', slug);
                    this._identity.setTeam(slug);
                    this._router.navigate(['/', slug]);
                  }
                }
              })
            );
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.forEach(s => s.unsubscribe());
  }
}
